// NPM Imports
import React from "react";

// Component Imports
import ConvertToImageFieldBtn from "./ConvertToImageFieldBtn";
// import ConvertToImageFieldUpgradeBtn from "./ConvertToImageFieldUpgradeBtn";
// import { FeatureGating } from "../../../commonComponents";

// Internal Imports
// import { FEATURES } from "../../../constants";

// Destructuring
// const { FEATURES_NAME } = FEATURES;

export default function(props) {
  // Note :: This will go later
  // return (
  //   <FeatureGating
  //     name={FEATURES_NAME.TEMPLATES_CLAUSE_OPTIONS}
  //     altComponent={
  //       <ConvertToImageFieldUpgradeBtn
  //         toggleUpgradePopup={props.toggleUpgradePopup}
  //         btnTitle={props.btnTitle}
  //       />
  //     }>
  //     <ConvertToImageFieldBtn {...props} />
  //   </FeatureGating>
  // );
  return <ConvertToImageFieldBtn {...props} />;
}



// WEBPACK FOOTER //
// ./src/components/DocumentItems/ConvertToImageFieldBtn/index.js